import {memoize} from '@packages/utilities/memo';
import {
  generatePlainText,
  generateImageUrl,
  itemCategories,
} from '@packages/shared/utils/SharedSampleDataUtils';
import {searchTitles} from '@packages/shared/constants/SampleData';

type Highlight = {
  value: string;
  isHighlighted: boolean;
};
const highlight = (
  query: string | null | undefined,
  snippet: string
): Highlight[] =>
  snippet.split(/\b/).map((value) => ({
    value,
    isHighlighted: query
      ? value.toLowerCase().startsWith(query.toLowerCase())
      : false,
  }));

type Edge = {
  title: string;
  pageUrl: string;
  snippet: string;
  description: string;
  image: {
    url: string;
  };
  highlightedSnippet?: Highlight[];
};

// Double array to have enough for <= 30 search results
const searchTitles2 = searchTitles.concat(searchTitles);
const sampleResults: Edge[] = searchTitles2.map((title) => {
  const snippet = generatePlainText(100, 300, true);
  return {
    title,
    pageUrl: '/sample-result',
    snippet,
    description: 'Sample search description',
    image: {
      url: generateImageUrl(itemCategories.GENERAL),
    },
  };
});

type ExampleEdge = {
  cursor: number;
  node: Edge;
};
type ExampleData = {
  loading: boolean;
  site: {
    search: {
      count: number;
      edges: ExampleEdge[];
    };
  };
};
const getExampleSearchResults = memoize(
  (
    query: string | null | undefined,
    resultsLength: number,
    snippetLength: number
  ): ExampleData => {
    const edges = sampleResults
      .filter(({title, snippet}) =>
        query
          ? (title + ' ' + snippet).toLowerCase().includes(query.toLowerCase())
          : true
      )
      .map((item, index) => {
        const snippet = item.snippet.slice(0, snippetLength).trim();
        return {
          cursor: index,
          node: {
            ...item,
            snippet,
            highlightedSnippet: highlight(query, snippet),
          },
        };
      })
      .slice(0, resultsLength);
    return {
      loading: false,
      site: {
        search: {
          count: edges.length,
          edges,
        },
      },
    };
  }
) as (
  arg1: string | null | undefined,
  arg2: number,
  arg3: number
) => ExampleData;

export default getExampleSearchResults;
